import type { ReactNode } from 'react';
import React from 'react';

import { Box } from '@mui/material';

import { GX_TEXT } from '@/constants/colors';

import AddApp from '@/assets/icons/AddApp';
import { Z_INDEX } from '@/constants/z-index';
import Typography from '@/shared/ui/typography/Text';

export const DrawerHeader = ({
  before,
  title,
  buttons
}: {
  before?: ReactNode;
  title: string;
  buttons: ReactNode;
}) => (
  <Box
    sx={{
      borderBottom: '1px solid',
      borderBottomColor: 'gx.textDisabled',
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      zIndex: Z_INDEX.floatingAnchor,
      backgroundColor: 'gx.mainBackground',
      pl: before ? 0 : 3
    }}
  >
    {before}
    <AddApp
      fill={GX_TEXT}
      sx={{
        width: '32px',
        height: '32px'
      }}
    />
    <Typography
      size={24}
      sx={{ fontWeight: 'bold', mr: 2, py: 3 }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        ml: 'auto',
        display: 'flex',
        gap: '2px',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '100%'
      }}
    >
      {buttons}
    </Box>
  </Box>
);
